// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from './../../../Assets/Js/helper';

import {FontAwesomeLoader} from "./FontAwesomeLoader";
import {initImprint} from '../../../Assets/Js/VXImprint';
import {initMobileMenu} from "../../../Assets/Js/VXProductLight/MobileMenu";
import {initCookieBanner} from "../../../Assets/Js/VXProductLight/CookieBanner";
import PaytourHelperClass from "../../../Assets/Js/paytour/PaytourHelperClass";

require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

declare global {
	interface Window { paytourHelper: PaytourHelperClass; }
}

helper.onDocumentLoaded(() => {
	FontAwesomeLoader();
	initCookieBanner();

	const wrapper = helper.$('#wrapper');
	const extender = helper.getData(wrapper, 'extend');
	const sender = parseInt(helper.getData(wrapper, 'host'));
	const loginButton = document.querySelector('.header-buttons-login');
	const isVxWorld = window.location.host.match(/visit-x\.world/) !== null;

	const paytourSettings = {
		lpId: 'Profile',
		hideSignupConfirmation: true,
		targetUrl: '',
		pfm: 1502,
		host: sender,
		option: '2XITGA',
		hideClose: false,
		disableJump: true,
	};
	const targetUrl = helper.getData(wrapper, 'target');
	const ab1 = parseInt(helper.getData(wrapper, 'ab1'));

	const links = helper.$('.paytour');

	for (let link of links) {
		if (!helper.hasClass(link, 'nopaytour')) {
			if (isVxWorld && link === loginButton) {
				helper.addClickListener(loginButton, (evt: MouseEvent) => {
					evt.preventDefault();
					window.location.href = 'https://www.visit-x.net?vxpAutoFlow=Login&s=' + sender + '&' + extender;
				});
			} else {
				helper.addEventListener(link, 'click', (evt: MouseEvent) => {
					evt.preventDefault();
					switch (ab1) {
						case 2:
							window.location.href = targetUrl;
							break;
						case 1:
							window.paytourHelper.openSignup(paytourSettings);
							break;
						case 0:
						default:
							window.paytourHelper.openPaytour(paytourSettings);
					}
				})
			}
		}
	}

	const video = helper.$('#video');
	const videoContainer = helper.$('#videoContainer');
	const videoPlaybutton = helper.$('#videoPlay');
	const preview = helper.$('#preview');

	helper.addEventListener(video, 'ended', () => {
		helper.hide(videoContainer);
		helper.show(videoPlaybutton, 'flex');
		helper.show(preview);
	})

	helper.addEventListener(videoPlaybutton, 'click', (evt: MouseEvent) => {
		evt.preventDefault();
		helper.show(videoContainer);
		helper.hide(videoPlaybutton)
		helper.hide(preview);
		video.play();
	})

	const imprintlink = helper.$('#impressumlink');
	const dsgvolink = helper.$('#datenschutzlink');

	initImprint(imprintlink, dsgvolink);
	initMobileMenu();
})
